import NProgress from 'nprogress'

function showLoaderDomUtil () {
  NProgress.start()
}

function hideLoaderDomUtil () {
  NProgress.done()
}

/**
 * Checks whether the node has the given className.
 * @param  {HTMLElement}  node
 * @param  {string}  className
 * @returns {boolean}
 */
function hasClassDomUtil (node, className) {
  return node.classList.contains(className)
}

function toggleClassDomUtil (node, className, toggle) {
  if (
    (toggle && !hasClassDomUtil(node, className)) ||
    (!toggle && hasClassDomUtil(node, className))
  ) {
    node.classList.toggle(className)
  }
}

export {
  showLoaderDomUtil,
  hideLoaderDomUtil,
  hasClassDomUtil,
  toggleClassDomUtil
}
